import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const InboxList = ({ messages, selectedId, onSelect }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full">
      <div className="px-4 py-2 border-b border-gray-200 flex items-center justify-between">
        <span className="text-sm font-semibold text-gray-700">
          {t("inbox")}
        </span>
      </div>
      <div className="flex-1 overflow-y-auto">
        {messages.length === 0 ? (
          <div className="h-full flex items-center justify-center text-sm text-gray-400">
            {t("emptyInboxTitle")}
          </div>
        ) : (
          messages.map((msg) => (
            <button
              key={msg.id}
              type="button"
              onClick={() => onSelect(msg.id)}
              className={`w-full text-left px-4 py-3 border-b border-gray-100 hover:bg-blue-50 ${
                selectedId === msg.id ? "bg-blue-50" : "bg-white"
              }`}
            >
              <div className="flex justify-between items-center mb-1">
                <span className="text-xs font-medium text-gray-700 truncate max-w-[60%]">
                  {msg.from || "(no sender)"}
                </span>
                <span className="text-[11px] text-gray-400">
                  {msg.receivedAt
                    ? dayjs(msg.receivedAt).format("HH:mm DD/MM")
                    : ""}
                </span>
              </div>
              <div className="text-sm text-gray-900 font-semibold truncate">
                {msg.subject || "(no subject)"}
              </div>
              {msg.hasAttachments && (
                <div className="mt-1 text-[11px] text-gray-500">
                  {t("attachments")}
                </div>
              )}
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default InboxList;

